import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowLeftExtraSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.116 15.926A1 1 0 0 0 10.5 16a1 1 0 0 0 .71-1.71l-.794-.79H16a1 1 0 0 0 0-2h-5.584l.794-.79a1.004 1.004 0 1 0-1.42-1.42l-2.5 2.5a1 1 0 0 0 0 1.42l2.5 2.5a1 1 0 0 0 .326.216"
    />
  </svg>
);
export default SvgArrowLeftExtraSmall;
